/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
export function formatNumber(value) {
  const num = Number(value);
  if (Number.isNaN(num)) return "0";

  return num.toLocaleString("en-US");
}
